'use client';

import { SignUpButton } from '@clerk/nextjs';
import { Button } from 'antd';
import { ArrowRight } from 'lucide-react';
import Link from 'next/link';
import { useOpenPanel } from 'providers';
import React, { useCallback } from 'react';

interface TrackedSignUpProps {
  isAuthenticated: boolean;
  theboatAppUrl: string;
}

const TrackedSignUp: React.FC<TrackedSignUpProps> = ({ isAuthenticated, theboatAppUrl }) => {
  const openPanel = useOpenPanel();

  const trackSignUp = useCallback(() => {
    openPanel.track('sign_up', { source: 'Home Page Apps Section' });
  }, [openPanel.track]);

  if (isAuthenticated) {
    return (
      <Button type="primary">
        <Link target="_blank" href={theboatAppUrl} rel="noreferrer">
          Go to TheBoatApp <ArrowRight size={16} />
        </Link>
      </Button>
    );
  }

  return (
    <SignUpButton>
      <Button variant="solid" type="primary" onClick={trackSignUp}>
        Get started for free
        <ArrowRight size={16} />
      </Button>
    </SignUpButton>
  );
};

export default TrackedSignUp;
